import React, { useContext, useRef } from "react";
import EmailEditor, { EditorRef, EmailEditorProps } from "react-email-editor";
import { HTMLToJSON } from "html-to-json-parser";

const HtmlEditor = ({
  json,
  updatedJsonData,
  jsonError,
  handleSaveDesign,
  getHtml,
  getJsonData,
}) => {
  const emailEditorRef = useRef(null);
  console.log(json, "iamjsonlf8346324763");
  const exportHtml = () => {
    const unlayer = emailEditorRef.current?.editor;
    unlayer?.exportHtml((data) => {
      const { design, html } = data;
      if (design) {
        const designData = JSON.stringify(design);
        getHtml(html);
        const fetch = async () => {
          if (json) {
            console.log("updatedJsonData", designData);
            updatedJsonData(designData);
            getHtml(html);
            handleSaveDesign();
          } else {
            getJsonData(designData);
            getHtml(html);
          }
        };
        fetch();
      }
    });
  };
  const onReady = (unlayer) => {
    // you can load your template here;
    // the design json can be obtained by calling
    // unlayer.loadDesign(callback) or unlayer.exportHtml(callback)
    // const templateJson = { DESIGN JSON GOES HERE };
    // unlayer.loadDesign(templateJson);
    // unlayer.loadDesign(json);
  };

  const loadDesign = (unlayer) => {
    if (json) {
      const myObject = JSON.parse(json);
      console.log(myObject,'myObjectssssslayer')
      if (myObject) {
        console.log(myObject,'myObjectsssss')
        unlayer.loadDesign(myObject);
      }
    }
  };
  React.useEffect(() => {
    const intervalId = setInterval(() => {
      exportHtml();
    }, 1000);

    return () => clearInterval(intervalId);
  }, [json]);
  console.log(json, "fhlasdjfhlasd");
  return (
    <div className="mb-1 flex  flex-col gap-2">
      <div>
        {
         json && <EmailEditor
            ref={emailEditorRef}
            onReady={onReady}
            onLoad={loadDesign}
          /> 
        }
        {
          !json && <EmailEditor
            ref={emailEditorRef}
            onReady={onReady}
            onLoad={loadDesign}
          /> 
        }
      </div>
    </div>
  );
};
export default HtmlEditor;
